import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { Skeleton } from "@/components/ui/skeleton";
import { ChartCard } from "./chart-card";
import { BAR_VALUE_LABEL, NO_ANIMATION } from "./chart-ticks";
import { COLORS } from "./utils";
import type { PriorityAreaRow } from "@/lib/statistics-api.service";

interface PriorityAreaChartProps {
	/** `undefined` = lần tải đầu chưa xong. */
	rows: PriorityAreaRow[] | undefined;
}

/** Biểu đồ cột theo khu vực ưu tiên: tổng, đã tiếp nhận, đã đóng học phí. */
export function PriorityAreaChart({ rows }: PriorityAreaChartProps) {
	if (rows === undefined) {
		return (
			<ChartCard title="Khu vực ưu tiên" filename="khu-vuc-uu-tien">
				<Skeleton className="h-[360px] w-full" />
			</ChartCard>
		);
	}

	if (rows.length === 0) {
		return (
			<ChartCard title="Khu vực ưu tiên" filename="khu-vuc-uu-tien">
				<p className="py-8 text-center text-sm text-muted-foreground">
					Chưa có dữ liệu khu vực ưu tiên trong phạm vi đang lọc.
				</p>
			</ChartCard>
		);
	}

	const data = rows.map((row) => ({
		label: row.label,
		Tổng: row.total,
		"Đã tiếp nhận": row.received,
		"Đã đóng học phí": row.paid,
	}));

	return (
		<ChartCard title="Khu vực ưu tiên" filename="khu-vuc-uu-tien">
			<ResponsiveContainer width="100%" height={360}>
				<BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="label" />
					<YAxis allowDecimals={false} />
					<Tooltip />
					<Legend />
					<Bar {...NO_ANIMATION} dataKey="Tổng" fill={COLORS[0]} label={BAR_VALUE_LABEL} />
					<Bar {...NO_ANIMATION} dataKey="Đã tiếp nhận" fill={COLORS[1]} label={BAR_VALUE_LABEL} />
					<Bar
						{...NO_ANIMATION}
						dataKey="Đã đóng học phí"
						fill={COLORS[2]}
						label={BAR_VALUE_LABEL}
					/>
				</BarChart>
			</ResponsiveContainer>
		</ChartCard>
	);
}
